import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: any | any[]): void {
    localStorage.setItem(key, value);
  }
}
